import { ArgsType, Field, Int } from '@nestjs/graphql'
import { GetArgsInterface } from '../base/getArgs.interface'

@ArgsType()
export class BaseGetArgs<T> implements GetArgsInterface {
  @Field(t => Int, { nullable: true })
  skip?: number

  @Field(t => Int, { nullable: true })
  take?: number

  @Field({ nullable: true })
  sortBy?: string

  @Field(t => Boolean, { nullable: true })
  descending?: boolean

  // Is this used on the front end where it doesn't need to be locked down to the user?
  @Field(t => Boolean, { nullable: true })
  genericSearch?: boolean

  // Add this here so we can easily implement search on any model
  // TODO: Remove from derived types that have done their own i.e GetBookArgs
  @Field({ nullable: true })
  genericSearchTerm?: string

  @Field(t => Int, { nullable: true })
  forUserId?: number

  public constructor (partial?: Partial<T>) {
    Object.assign(this, partial)
  }
}
